exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".yf_8XajjQlgzvhc9C5DwS{font-size:16px}html[dir=ltr] .yf_8XajjQlgzvhc9C5DwS{padding-left:0}html[dir=rtl] .yf_8XajjQlgzvhc9C5DwS{padding-right:0}", ""]);
// Exports
exports.locals = {
	"star": "yf_8XajjQlgzvhc9C5DwS"
};